import { useEffect, useRef } from "react";

// Scroll-reveal hook — adds "visible" class when element enters viewport
export function useReveal<T extends HTMLElement>() {
    const ref = useRef<T>(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
            if (entry?.isIntersecting) {
                    el.classList.add("revealed");
                    obs.disconnect();
                }
            },
            { threshold: 0.12 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);
    return ref;
}
